module.exports = __webpack_public_path__ + "img/stop.77e6118e.svg";